import {GitMergeIcon} from '@primer/octicons-react'
import {usePullRequestState} from '../../../../hooks/use-pull-request-state'
import {PullRequestState} from '../../../../types'
import type {ViewerRole} from '../deciders/use-decide-next-action'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {DeleteHeadBranch, shouldShowDeleteHeadBranch} from './DeleteHeadBranch'
import {useMergeabilityData} from '../mergeability/use-mergeability-data'

export function shouldShowMergedPR(pullRequestState: PullRequestState) {
  return pullRequestState === PullRequestState.Merged
}

export function MergedPR({variant, userRole}: {variant?: 'default' | 'embedded'; userRole?: ViewerRole}) {
  const pullRequestState = usePullRequestState()
  const mergeabilityData = useMergeabilityData()

  if (!shouldShowMergedPR(pullRequestState)) return null

  if (userRole && userRole !== 'author') {
    return <MergedStatus variant={variant} />
  }

  if (shouldShowDeleteHeadBranch(mergeabilityData)) {
    return <DeleteHeadBranch variant={variant} />
  }

  return <MergedStatus variant={variant} />
}

function MergedStatus({variant}: {variant?: 'default' | 'embedded'}) {
  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={GitMergeIcon} variant="done" />}
      title="Merged"
      itemName="merged"
      variant={variant}
      description="This pull request was merged. Nothing to do."
    />
  )
}
